import { render } from "./NotificationsBlock.vue?vue&type=template&id=9da31ebe"
import script from "./NotificationsBlock.vue?vue&type=script&lang=js"
export * from "./NotificationsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__